
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/components/facet/js/toggle';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/node_modules/ui-core/components/facet-date/js/facet-date';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/node_modules/ui-core/components/facet-date-chart/js/facet-date-chart';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/node_modules/ui-core/components/refine-search/js/refine-search';
  
import AdvancedSearch from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/node_modules/ui-core/widgets/advanced-search/js/advanced-search';  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/widgets/search-result/js/search-result';
  
const main = (UX) => {
    const $toggle = Array.prototype.slice.call(document.getElementsByClassName('facet')),
        $facetDate = Array.prototype.slice.call(document.getElementsByClassName('range-slider')),
        $facetDateChart = Array.prototype.slice.call(document.getElementsByClassName('facetDateChart')),
        $refine = Array.prototype.slice.call(document.querySelectorAll('.refineSearch,.advanced-search')),
        $advancedSearch = document.querySelector('.advanced-search'),
        $searchResult = Array.prototype.slice.call(document.getElementsByClassName('search-result'))

try {
        if ($toggle.length ) {
            UX.toggle.init($toggle);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($facetDate.length ) {
            UX.facetDate.init($facetDate);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($facetDateChart.length ) {
            UX.facetDateChart.init($facetDateChart);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($refine.length ) {
            UX.refine.init($refine);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($advancedSearch ) {
            UX.advancedSearch = new AdvancedSearch($advancedSearch).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($searchResult.length ) {
            UX.searchResult.init($searchResult);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        